import { useCallback } from 'react';
import tracker from '../utils/tracker';

export const useTracker = () => {
  const trackButton = useCallback((button: string, input = "", value = "", errormsg = "") => {
    tracker(button, input, value, errormsg);
  }, []);

  const trackInput = useCallback((input: string, value: string, errormsg = "") => {
    tracker("", input, value, errormsg);
  }, []);

  const trackError = useCallback((errormsg: string, button = "", input = "", value = "") => {
    tracker(button, input, value, errormsg);
  }, []);

  const trackCalculatorUsage = useCallback((calculator: string, action: string, details = "") => {
    tracker(action, "calculator", calculator, details);
  }, []);

  return {
    trackButton,
    trackInput,
    trackError,
    trackCalculatorUsage
  };
}; 